<template>
    <t-section v-bind:schemaName="'systemSetting'" v-bind:fields="fields" v-bind:headers="headers"></t-section>
</template>

<script>
    import TSection from '@/components/Sections/Section.vue';
    export default {
        name: "SystemSettingSection",
        components:{
            TSection,
        },
        data() {
            return {
                headers:[
                    { field:"name", name:this.fieldLabel("name", "Назва"), sort:true, router: { field:"id", name:"SystemSettingPage" }},
                    { field:"code", name:this.fieldLabel("code", "Код"), sort:true,  router: { field:"id", name:"SystemSettingPage" } },
                ],
                fields:[
                    { field: "name", name: this.fieldLabel("name", "Назва"), type:"string" },
                    { field:"code", name:this.fieldLabel("code", "Код"), type: "string" },
                ],
            }
        },
        methods: {
            fieldLabel(field, fallback) {
                return this.$filters.localize(`SystemSettingPage.fields.${field}`) || fallback;
            },
        },
    }
</script>
